<template lang="pug">
  div.root(ref="root")
    mail-chat-messages(:room="currentMailRoom"
                  :senderId="senderId",
                  :senderName="senderName",
                  senderType="user",
                  :sessionToken="currentUser ? currentUser.accessToken : null"
                  :messageLoading="messageLoading"
                  :displayVisibilityState="displayVisibilityState"
                  @view-new-mail-chat="viewNewMailChat"
                  @enter-room="onEnterRoom",
                  @fetch-new-messages="onFetchNewMessages"
                  @update-messages="onUpdateMessages"
                  @set-product-code="setProductCode"
                  @set-message-loading="setMessageLoading"
                  @chat-is-closed="onChatClosed"
                  @reload-system-state="reloadSystemState"
                  @read-sinceId-clear="readSinceIdClear"
                  @create-notice-timer="createNoticeTimer"
                  @start-polling="startPolling"
                  @stop-polling="stopPolling"
                  @set-business-hours="exeApiGetBusinessHours"
                  )
    v-card.chat-input(ref="input")
      v-card-actions
            //- v-text-field(label="入力" v-model="inputText")
      <v-layout row>
        <v-flex class="chatClosed" lg10 xs12 v-if="$options.chatClient && isClosed">
          <p>このチャットは終了しました。</p>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex lg10 xs12>
          textarea(
                    placeholder="入力"
                    rows="3"
                    v-model="inputText"
                    ref="inputText"
                    @focus="focusUserInputCheck"
                    @blur="blurUserInputCheck"
                    :disabled="!isTextAreaActive() || !freetextAvailable || isClosed"
                  )
        </v-flex>
        <v-flex lg1 xs12>
          v-btn.send_btn(light @click="sendText" :disabled="!isFormSubmittable() || !freetextAvailable") 送信
        </v-flex>
        <v-flex lg1 xs12>
          v-btn.amber(icon dark
                    @click="onClickOpenFolder"
                    :disabled="isFileSendButtonDisabled() || !freetextAvailable")
            v-icon folder_open
        </v-flex>
      </v-layout>

        input(type="file" accept="image/*" capture="camera"
              ref="fileInput" @change="onChangeFile" :disabled="!freetextAvailable")
</template>

<script>
import * as $ from 'jquery'
import 'string.prototype.startswith'

import BaseComponent from '@/components/BaseComponent'
import Const from '@/util/const'
import MailChatMessages from '@/../app-common-vue/src/components/MailChatMessages'
import ChatClient from '@/../app-common-vue/src/lib/ChatClient'
import Moment from 'moment'
import {
  toAscii
} from 'japanese-string-utils'

// ファイルサイズ制限：10M
const FILE_SIZE_LIMIT = 10 * 1024 * 1024
const AFTER_BUSINESS_HOURS = 1
const ENTERING = 1
const NOT_ENTERING = 0
const ENTERING_TIME = 2000 // ミリ秒
const RESIZE_TIME = 500 // ミリ秒
const NOTICE_SITTING_TIME = 60000 // ミリ秒
const USER_INPUT_TIME = 3000
const SEATED = 0
const NOT_SEATED = 2
const SEATED_TIME = 120 // 秒
const OPERATION_MODE_BOT = 0 // 無人チャット対応中
const INITIAL_OPERATION_MODE = OPERATION_MODE_BOT
const OPERATION_MODE_OPERATOR = 1 // 有人チャット対応中
const CHECK_COMMENT_SENDER_OP = ['op', 'sv']

export default {
  name: 'Mail',
  extends: BaseComponent,
  components: {
    'mail-chat-messages': MailChatMessages
  },
  data: function () {
    return {
      reSizeTimer: '',
      inputText: '',
      result: {},
      op_seated_result: NOT_SEATED,
      reloadTimer: '',
      reloadTime: 60, // 秒
      businessHourStart: '',
      businessHourEnd: '',
      NOT_SEATED: NOT_SEATED,
      AFTER_BUSINESS_HOURS: AFTER_BUSINESS_HOURS,
      ENTERING: ENTERING,
      NOT_ENTERING: NOT_ENTERING,
      entering: '',
      enteringTimer: '',
      noticeSettingTimer: '',
      seatedTimer: '',
      operationMode: OPERATION_MODE_BOT,
      productCategory: '',
      trourbleCategory: '',
      rawProductCode: '',
      freetextAvailable: false,
      isClosed: false,
      messageLoading: false,
      userInputCheckTimer: '',
      displayVisibilityState: Const.stateVisible
    }
  },
  // options
  chatClient: null,
  polling: null,

  computed: {
    senderId () {
      return this.currentUser ? this.currentUser.id : 'anonymous'
    },
    senderName () {
      return this.currentUser ? this.currentUser.name : 'お客様'
    },
    productCode: {
      get () {
        return toAscii(this.rawProductCode)
      },
      set (value) {
        console.log(value)
        this.rawProductCode = toAscii(value)
      }
    }
  },

  mounted: function () {
    this.resizeHeight()
    // visibilitychangeイベントを追加
    document.addEventListener('visibilitychange', this.handleVisibilityChange)
  },

  created: function () {
    // 営業時間取得のAPIを実行
    this.exeApiGetBusinessHours()

    // 現行のポーリング処理で実装したとしても1～3秒間隔でAPIコールされるため、実装難易度が低いタイマーコールを採用
    // チャットメッセージ入力中確認タイマーセット
    this.createEntringTimer()

    // チャット画面の高さを計算するタイマーセット
    this.reSizeTimer = setInterval(() => { this.onResize() }, RESIZE_TIME)

    // 営業時間内だった場合、オペレーターの空き状況を確認
    if (this.result.res !== AFTER_BUSINESS_HOURS) {
      // オペレーターの空き状況チェックAPIを実行
      this.exeApiSeatedOperators()
    }
    this.initialTextInput()
  },

  beforeDestroy: function () {
    // チャットメッセージ入力中確認タイマー停止
    clearInterval(this.enteringTimer)
    // 営業時間外タイマー停止
    clearInterval(this.reloadTimer)
    // リサイズタイマー停止
    clearInterval(this.reSizeTimer)
    // 在席通知タイマー停止
    clearInterval(this.noticeSettingTimer)
    // 入力中通知タイマー停止
    clearInterval(this.userInputCheckTimer)
    // visibilitychangeイベントを削除
    document.removeEventListener('visibilitychange', this.handleVisibilityChange)
  },

  watch: {
    // 営業時間外の場合の自動リロードタイマー
    reloadTime: function (v) {
      if (this.operationMode === OPERATION_MODE_BOT) return
      if (this.op_seated_result === SEATED) return
      if (v > 0) return

      document.location = '/user/'
    },
    displayVisibilityState (newVal) {
      if (newVal === Const.stateVisible) {
        // 入力中確認再開
        this.createEntringTimer()
        // 在席通知再開
        this.createNoticeTimer()

        // 既読状態を更新
        this.api.updateReadDisplay(this.currentMailRoom.id)
        .catch(err => {
          console.log(err)
        })
      }

      if (newVal === Const.stateHidden) {
        // チャットメッセージ入力中確認タイマー停止
        clearInterval(this.enteringTimer)
        // 在席通知タイマー停止
        clearInterval(this.noticeSettingTimer)
        // 入力中通知タイマー停止
        clearInterval(this.userInputCheckTimer)
      }
    },
    // 各タイマーが複数生成されて動作しないようにする制御
    enteringTimer: function (newVal, oldVal) {
      if (oldVal === '') return
      clearInterval(oldVal)
    },
    userInputCheckTimer: function (newVal, oldVal) {
      if (oldVal === '') return
      clearInterval(oldVal)
    },
    noticeSettingTimer: function (newVal, oldVal) {
      if (oldVal === '') return
      clearInterval(oldVal)
    }
  },
  methods: {
    handleVisibilityChange () {
      // visibilitychangeイベントで実行される
      this.displayVisibilityState = document.visibilityState
    },

    exeApiGetBusinessHours () {
      // 営業時間内か営業時間外か確認
      this.api.getBusinessHours().then(res => {
        this.result = res.data
        if (this.result.res === AFTER_BUSINESS_HOURS) {
          this.businessHour = this.result.data
          this.businessHourStart = Moment(this.result.data.business_start_time).utc().format('H:mm')
          this.businessHourEnd = Moment(this.result.data.business_end_time).utc().format('H:mm')
          clearInterval(this.reloadTimer)
          this.reloadTimer = setInterval(() => { this.reloadTime-- }, 1000)
        }
      })
      .catch(err => {
        this.handleError('営業時間の取得に失敗しました', err)
      })
    },

    exeApiSeatedOperators () {
      // 在席中のオペレーターがいるか確認
      let paramRoomId = null
      // ルーム接続中の場合はオペレーターが空いていなくてもIDを渡して再接続させる
      if (this.currentMailRoom) {
        paramRoomId = this.currentMailRoom.id
      }

      this.api.getSeatedOperators(paramRoomId).then(res => {
        if (res.data === NOT_SEATED) {
          this.op_seated_result = NOT_SEATED
          this.reloadTime = SEATED_TIME
          // 対応可能になったオペレーターがいないか確認する為のタイマーをセット
          this.seatedTimer = setInterval(() => { this.reloadTime-- }, 1000)
        } else { // 初期値が混雑なので空いていれば空きに書き換える
          this.op_seated_result = SEATED
        }
      })
    },

    reloadSystemState () {
      this.exeApiGetBusinessHours()
      this.exeApiSeatedOperators()
    },

    // メッセージ既読状態取得ポーリング開始
    startPolling () {
      if (this.$options.polling !== null) return
      this.$options.polling = this.api.getReadMessages(this.currentMailRoom.id, 'user')
      this.$options.polling.onFetch =
          (states) => this.onMessagesRead(states)
      this.$options.polling.start()
    },

    // 既読情報の取得
    onMessagesRead (res) {
      this.$nextTick(() => {
        if (res.length > 0) {
          res.forEach((value, index) => {
            if ($(`#${value.id}`).length) {
              $(`#${value.id}`).text('既読')
            }
          })
        }
      })
    },

    // メッセージ既読状態取得ポーリング停止
    stopPolling () {
      if (this.$options.polling) {
        this.$options.polling.stop()
        this.$options.polling = null
      }
    },

    // テキストエリアの初期値を設定
    initialTextInput () {
      this.inputText = ''
    },
    // チャット画面の高さを計算
    resizeHeight () {
      let root = $(this.$refs.root)
      let input = $(this.$refs.input)

      let bodyHeight = $('body').height()
      let top = root.offset().top
      let inputHeight = input.prop('offsetHeight')

      root.height(bodyHeight - top - inputHeight)
    },

    onEnterRoom: function (roomProps) {
      this.operationMode = INITIAL_OPERATION_MODE
      this.setCurrentMailRoom(roomProps)
      this.isClosed = false
      let roomId = roomProps.roomId
      this.$options.chatClient = new ChatClient(this.api, roomId)
      this.freetextAvailable = false
      this.$options.chatClient.sender = {
        id: this.senderId,
        name: 'お客様',
        role: 'user'
      }
      this.initialTextInput()
    },

    viewNewMailChat (state) {
      // viewNewChatFlgを設定
      // Header.vueの表示制御に使用する
      this.setviewNewMailChatFlg(state)
    },

    onFetchNewMessages (messages) {
      if (messages[messages.length - 1].context !== 'question') {
        this.setMessageLoading(false)
      }

      // 最新のBotメッセージに応じた処理
      const botMessages = messages.filter((message) => message.sender.role === 'bot')
      if (botMessages.length !== 0) {
        const latestBotMessage = botMessages[botMessages.length - 1]
        console.log(`freetext: ${latestBotMessage.content.freetext_processible}`)
        this.freetextAvailable = latestBotMessage.content.freetext_processible
      }

      if (this.op_seated_result === NOT_SEATED) {
        // OPの在籍の確認ができていない場合
        if (messages.filter((message) => CHECK_COMMENT_SENDER_OP.includes(message.sender.role)).length > 0) {
          // OP,SVの発言が確認できれば、在籍確認結果を更新する
          this.op_seated_result = SEATED
        }
      }

      if (messages.filter((message) => message.context === 'call-operator' || message.context === 'calling-operator').length > 0) {
        // OP呼び出しの選択 or OP呼び出しのメッセージがある場合
        this.operationMode = OPERATION_MODE_OPERATOR
      }

      // 修理申込みへ遷移
      if (!messages.length === 1) return
      const newMessage = messages[0]
      if (newMessage.type !== 'ButtonClick') return

      let btn = newMessage.content.button
      if (!btn.value.startsWith) return
      if (!btn.value.startsWith('request_repair:')) return

      let splited = btn.value.split(':')
      if (splited.length < 2) return

      let productId = splited[1]
      this.$router.push({ path: `/repair?productId=${productId}` })
    },
    onUpdateMessages (containerHeight) {
      $(this.$refs.root).animate({scrollTop: containerHeight})
    },
    sendText: function () {
      if (!this.$options.chatClient) { return }

      if (this.operationMode === OPERATION_MODE_BOT) {
        const category = `${this.productCategory}`
        this.setMessageLoading(true)
        this.$options.chatClient.sendQuestion(this.inputText, category, this.productCode)
      } else {
        this.$options.chatClient.sendText(this.inputText)
        this.$options.chatClient.unreadText()
      }
      this.inputText = ''
    },
    onClickOpenFolder () {
      this.$refs.fileInput.click()
    },
    onChangeFile (e) {
      if (e.target.files.length === 0) return

      let roomId = this.currentMailRoom.id
      let file = e.target.files[0]

      if (FILE_SIZE_LIMIT < file.size) {
        alert('ファイルサイズが大きすぎます。')
        return
      }

      this.api.sendRoomFile(roomId, file).then(res => {
        if (this.$options.chatClient) {
          let fileId = res.data.id
          let accessToken = res.data.access_token
          let sendMsg = this.$options.chatClient.sendFile(fileId, accessToken, file)
          sendMsg.then(res => {
            this.$refs.fileInput.value = null
          })
          .catch(err => {
            this.handleError('ファイルの送信に失敗しました。', err)
          })
        }
      })
      .catch(err => {
        this.handleError('ファイルの送信に失敗しました。', err)
      })
    },

    // 入力中状態取得タイマー作成
    createEntringTimer () {
      this.enteringTimer = setInterval(() => { this.onEntring() }, ENTERING_TIME)
    },

    // 入力中statusの取得
    onEntring () {
      this.api.enteringCheck(this.currentMailRoom.id).then(res => {
        this.entering = res.data
      })
      .catch(err => {
        this.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err)
      })
    },

    // 在席通知タイマー作成
    createNoticeTimer () {
      // 初回読込時用
      this.onNoticeSetting()
      // タイマー作成
      this.noticeSettingTimer = setInterval(() => { this.onNoticeSetting() }, NOTICE_SITTING_TIME)
    },

    // サーバーに在席状況を送信する
    onNoticeSetting () {
      this.api.postSittingTime(this.currentMailRoom.id)
      .catch(err => {
        this.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err)
      })
    },

    onChatClosed () {
      console.log('Closing')
      this.$nextTick(() => (this.isClosed = true))
      this.stopPolling()
    },

    setProductCode (code) {
      this.productCode = toAscii(code)
    },

    setMessageLoading (value) {
      this.messageLoading = value
    },

    onResize () {
      this.resizeHeight()
    },

    // メッセージ入力欄がフォーカスされた場合に入力中と判断
    focusUserInputCheck () {
      this.userInputCheckTimer = setInterval(() => { this.onUserInputSetting() }, USER_INPUT_TIME)
    },

    onUserInputSetting () {
      this.api.userInputCheck(this.currentMailRoom.id)
      .catch(err => {
        this.handleError('ネットワークが不安定な為、通信に時間がかかっています。', err)
      })
    },

    // メッセージ入力欄からフォーカスが外れた場合に非入力中と判断
    blurUserInputCheck () {
      clearInterval(this.userInputCheckTimer)
    },

    isTextAreaActive () {
      if (this.$options.chatClient === null) return false
      if (this.operationMode === OPERATION_MODE_BOT) return true
      if (this.result.res === AFTER_BUSINESS_HOURS) return false

      return true
    },

    isFormSubmittable () {
      return (this.inputText.length !== 0) && this.isTextAreaActive()
    },

    isFileSendButtonDisabled () {
      if (this.$options.chatClient === null) return true
      if (this.operationMode === OPERATION_MODE_BOT) return true
      if (this.result.res === AFTER_BUSINESS_HOURS) return true
      if (this.op_seated_result === NOT_SEATED) return true

      return false
    },

    isBotMode () {
      return this.operationMode === OPERATION_MODE_BOT
    }
  }
}
</script>

<style lang="scss" scoped>
.root {
  overflow-y: auto;
  margin-top: -74px;
}
.send_btn {
  color: #ffffff !important;
  background-color: #000000 !important;
  border-style: solid;
  border-color: #ffffff;
}
.chat-input {
  overflow-y: auto;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  max-height: 250px;
  padding-left: 10px;
  padding-right: 10px;
  background-color: #000000
}
input[type = 'file'] {
  display: none;
}
textarea {
  background-color: #ffffff;
  resize: vertical;
  outline: solid 2px #CCCCCC;
  width: 100%;
  box-sizing: border-box;
  font-size: 16px;
}
textarea:focus {
  outline: solid 2px #1976d2;
}
.businessHour {
  text-align: left;
  color: #ffffff;
}
.operatorNotSeated {
  text-align: left;
  color: #ffffff;
}
.chatClosed {
  text-align: left;
  color: #ffffff;
}
.entering {
  text-align: left;
  color: #ffffff;
  animation-name: fadein;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

@keyframes fadein {
from {
    opacity: 0;
}
to {
    opacity: 1;
}
}
</style>



// WEBPACK FOOTER //
// src/components/MailChat.vue?747e02b2